import TransferReceiverSelect from "./transferReceiverSelect.container";

export default TransferReceiverSelect;
